// @ts-nocheck
import { message } from 'antd';
import { graphql } from '@apollo/client/react/hoc';
import { UPDATE_RESPONSE_MUTATION } from '../graphql/updateReasponseMutation.gql';


export const withUpdateResponse = Component =>
    graphql(UPDATE_RESPONSE_MUTATION, {
        props: ({ mutate, history }) => ({
            updateResponse: async values => {
                try {
                    const {
                        data: { updateResponse }
                    } = await mutate({
                        variables: {
                            ...values
                        }
                    });

                    message.destroy();
                    message.success("Successfully updated")
                    return updateResponse.response;
                } catch (e) {
                    message.destroy();
                    message.error("Failed to updated")
                    console.error(e);
                }
            }
        })
    })(Component);

